module.exports = __webpack_public_path__ + "static/img/img_cabinet.df97d244.png";